import {
  Component, ChangeDetectionStrategy, Input,
} from '@angular/core'

import {
  PictureSources, PictureVariants,
} from '@knorr-bremse-portals/ngx-components/components/picture'
import {
  ColumnWidth, PlainLink,
} from '@knorr-bremse-portals/ngx-components'
import { HeroVideoComponent } from '@knorr-bremse-portals/ngx-components/components/hero/hero-video'
import { HeroPictureComponent } from '@knorr-bremse-portals/ngx-components/components/hero/hero-picture'
import { CropType } from '@knorr-bremse-portals/ngx-components/components/video'
import { HeadingLevel } from '@knorr-bremse-portals/ngx-components/components/variable-heading'
import { AbstractMode } from '@knorr-bremse-portals/ngx-components/components/overlay-figure'

export interface HeroPicture {
  type: 'picture'
  variants?: PictureVariants
  picture: PictureSources
  alt: string
  heading?: string
  headingLevel?: HeadingLevel
  abstract?: string
  link?: PlainLink
}

export function isHeroPicture(item: HeroItem): item is HeroPicture {
  return item.type === 'picture'
}

export interface HeroVideo {
  type: 'video'
  src: string
  poster: string
  crop?: CropType
  autoplay?: boolean
  loop?: boolean
  heading?: string
  headingLevel?: HeadingLevel
  abstract?: string
}

export function isHeroVideo(item: HeroItem): item is HeroVideo {
  return item.type === 'video'
}

export type HeroItem = HeroPicture | HeroVideo

@Component({
  selector: 'kb-hero-item',
  templateUrl: './hero-item.component.html',
  styleUrls: ['./hero-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeroPictureComponent, HeroVideoComponent],
})
export class HeroItemComponent {
  @Input({ required: true }) public item!: HeroItem
  @Input({ required: true }) public rootColumns!: ColumnWidth
  @Input() public aboveFold = true
  @Input() public indented = true
  @Input() public largeHeading = true
  @Input() public abstractMode: AbstractMode = 'visible'

  protected isHeroPicture = isHeroPicture
  protected isHeroVideo = isHeroVideo
}
